import React, { useContext, useEffect, useState } from 'react';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { useLayoutGroupProps, withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { RecsContext } from '../RecsContext';
import { dataModel } from './dataModel';

const RecommendationsPlaceholderComponent = (props) => {
  const context = useContext(RecsContext);
  const expContext = useContext(ExperienceContext);
  const {
    scheme,
    schema,
    itemId,
    hideRecommendation,
    defer,
    shouldDisplayCard
  } = props;
  const path = expContext?.path;
  const isServer = expContext?.isServer;
  const { channel } = expContext;
  const { updateResx, addSchema, getResx } = context;
  const [showRecsHeader, setShowRecsHeader] = useState(false);
  const { useNewImpressionLogic, useBannerPlaceholder } = useLayoutGroupProps({ props });

  useEffect(() => {
    if (addSchema) {
      addSchema(scheme || schema, defer);
    }
  }, [scheme, schema]);

  useEffect(() => {
    if (updateResx) {
      if (useNewImpressionLogic) {
        updateResx({ useNewImpressionLogic: true });
      }
    }
  }, []);

  useEffect(() => {
    const validReferrer = /google\.com|bing\.com|yahoo\.com/.test(window.document.referrer);
    const externalRedirect = /cm_mmc/.test(path);
    const shouldShow = externalRedirect || (!isServer && validReferrer);
    setShowRecsHeader(shouldShow);
  }, [isServer, path]);

  const schemen = scheme || schema;
  const storeId = useStoreId();
  const { data, loading } = useProductDeprecated({
    itemId,
    storeId,
    domains: ['media', 'fulfillment'],
    skip: !itemId || ((schemen !== 'visuallysimilar_1_0' || !itemId || channel === 'mobile') && storeId === '8119'),
    ssr: false
  }, 'clientOnlyProduct');

  useEffect(() => {
    const visSimCard = shouldDisplayCard && schemen === 'visuallysimilar_1_0';
    if (data && !visSimCard && updateResx) {
      const primary = data.product?.media?.images?.find((img) => img.subType === 'PRIMARY');
      const index = primary?.sizes?.indexOf('400');
      if (index > -1) {
        const productImageURL = primary.url.replace('<SIZE>', '400');
        if (productImageURL) {
          updateResx({ visSim: { productImageURL } });
        }
      }
    } if (visSimCard && updateResx) {
      updateResx({ card: true });
    }
  }, [data]);

  if (hideRecommendation && (schemen === 'pipsem' || schemen === 'pip_sem_mobile'
     || schemen === 'PIPHorizontal2_rr') && !showRecsHeader) {
    return null;
  }

  if (useBannerPlaceholder && schemen.indexOf('sponsored__banner') > -1) {
    let windowFunc;
    if (typeof window !== 'undefined') {
      windowFunc = window.__GET_RESX__;
    }

    const getResxFunc = getResx || windowFunc || function () { return {}; };
    const resx = getResxFunc();

    if (resx.fetchBanner) {

      const defaultBannerMap = [
        {
          imgDesktop: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/app-desktop.jpg',
          imgMobile: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/app-mobile.jpg',
          clickthruURL: 'https://www.homedepot.com/c/SF_Mobile_Shopping'
        },
        {
          imgDesktop: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/bopis-desktop.jpg',
          imgMobile: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/bopis-mobile.jpg',
          clickthruURL: 'https://www.homedepot.com/c/pick_up_in_store'
        },
        {
          imgDesktop: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/delivery-desktop.jpg',
          imgMobile: 'https://contentgrid.thdstatic.com/hdus/en_US/DTCCOMNEW/fetch/delivery-mobile.jpg',
          clickthruURL: 'https://www.homedepot.com/c/About_Your_Online_Order'
        },
      ];

      const defaultBanner = defaultBannerMap[Math.floor(Math.random() * 3)];
      defaultBanner.url = defaultBanner.imgDesktop;
      if (channel === 'mobile') {
        defaultBanner.url = defaultBanner.imgMobile;
      }

      let imgSrc = defaultBanner.url;
      let href = defaultBanner.clickthruURL;
      if (typeof window !== 'undefined') {
        try {
          const aTag = window.document.querySelector(`#${schemen} a`);

          imgSrc = aTag.dataset.img;
          href = aTag.href;
        } catch (error) { /* */ }
      }

      const paddingTop = channel === 'mobile' ? '37.7%' : '10.6%';

      const cssObj = {
        width: '100%',
        display: 'block',
        'box-sizing': 'border-box',
        background: `url("${imgSrc}") no-repeat`,
        'background-size': '100%',
        'padding-top': paddingTop
      };

      return (
        <div
          data-usebannerplaceholder="true"
          id={schemen}
        >
          <div id="default_banner_carousel">
            { /* eslint-disable-next-line */ }
            <a href={href} style={cssObj} data-img={imgSrc} />
          </div>
        </div>
      );
    }
  }

  return (
    <div id={schemen} />
  );
};

RecommendationsPlaceholderComponent.displayName = 'RecommendationsPlaceholder';

const propTypes = {
  defer: PropTypes.bool,
  itemId: PropTypes.string,
  scheme: PropTypes.string.isRequired,
  schema: PropTypes.string,
  hideRecommendation: PropTypes.bool,
  shouldDisplayCard: PropTypes.bool
};
const defaultProps = {
  defer: false,
  itemId: null,
  schema: null,
  hideRecommendation: false,
  shouldDisplayCard: false
};

RecommendationsPlaceholderComponent.propTypes = propTypes;
RecommendationsPlaceholderComponent.defaultProps = defaultProps;
RecommendationsPlaceholderComponent.dataModel = dataModel;

const RecommendationsPlaceholder = withLayoutGroup({ name: 'default-recs' }, RecommendationsPlaceholderComponent);
RecommendationsPlaceholder.propTypes = propTypes;
RecommendationsPlaceholder.defaultProps = defaultProps;
RecommendationsPlaceholder.dataModel = dataModel;
export { RecommendationsPlaceholder };
